<div
  [ngClass]="fromPhoneBookPage ? 'lg:mt-[100px] mx-auto max-w-lg' : 'max-w-[465px] mx-auto lg:mx-0'"
  class="bg-white w-full rounded-lg pt-[16px] px-2 mt-5 pb-5 search-width-fix lg:px-8 lg:pb-12 lg:mb-3">
  <div class="hidden lg:block text-lg leading-[42px] font-medium text-center lg:text-left mb-8">
    {{ header || title }}
  </div>

  <span class="text-black text-base font-normal lg:hidden">{{ title }}</span>
  <bey-input
    *ngIf="showSearchBarOnMount"
    placeholder="Search"
    name="query"
    type="search"
    class="mt-2.5"
    getElementId
    getElementIdDescription="search"
    (input)="filterContacts($event)">
    <div class="flex justify-center items-center pl-2" prepend>
      <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path
          d="M6.31259 10.2399C8.80008 10.2399 10.8166 8.22342 10.8166 5.73593C10.8166 3.24844 8.80008 1.23193 6.31259 1.23193C3.8251 1.23193 1.80859 3.24844 1.80859 5.73593C1.80859 8.22342 3.8251 10.2399 6.31259 10.2399Z"
          stroke="#2F2F2E"
          stroke-width="1.2" />
        <path d="M9.80859 9.51221L14.0086 14.0162" stroke="#2F2F2E" stroke-width="1.2" stroke-linecap="round" />
      </svg>
    </div>
  </bey-input>

  <div style="margin-left: -32px" class="flex flex-wrap mt-2.5">
    <ng-container *ngIf="contactsIsLoading; else readyToGo">
      <div
        *ngFor="let avatar of [].constructor(fromPhoneBookPage ? 10 : 7)"
        class="flex items-center flex-col ml-8 mb-8">
        <bey-avatar size="h-[60px] w-[60px] " [isSkeleton]="true"> </bey-avatar>
      </div>
    </ng-container>
    <ng-template #readyToGo>
      <div
        *ngIf="showPlusSign"
        (click)="onPlusSignClick()"
        class="ml-8 mb-8 mt-4 flex flex-col items-center cursor-pointer min-w-[64px]"
        HasPermission
        [expectedPermission]="expectedPermission">
        <svg width="30" height="30" viewBox="0 0 30 30" fill="none" xmlns="http://www.w3.org/2000/svg">
          <path d="M15 6.90039V23.3704" stroke="#006FAB" stroke-width="3.5" stroke-linecap="round" />
          <path d="M24.1803 15.1353H5.82031" stroke="#006FAB" stroke-width="3.5" stroke-linecap="round" />
        </svg>
        <span class="text-base font-medium text-blue-400 mt-3">New</span>
      </div>
      <ng-container *ngFor="let contact of contacts$ | async">
        <div class="flex items-center flex-col ml-8 mb-8 cursor-pointer" (click)="selectContact(contact)">
          <bey-avatar size="h-[60px] w-[60px]">
            <span class="font-medium text-2xl leading-[28px] mt-[5px]">{{
              contact.first_name ? (contact.first_name + ' ' + contact.last_name | nameInitials) : '-'
            }}</span>

            <ng-container name>
              <span
                class="text-sm text-gray-500 text-center leading-[16px] mt-2.5 mx-auto max-w-[4rem] break-all line-clamp-2 lg:text-base">
                <ng-container *ngIf="contact.first_name; else anonymous">
                  {{ contact.first_name | titlecase }} <br />
                  {{ contact.last_name | titlecase }}
                </ng-container>
                <ng-template #anonymous>
                  {{ contact.phone | formatPhone }}
                </ng-template>
              </span>
            </ng-container>
          </bey-avatar>
        </div>
      </ng-container>
    </ng-template>

    <ng-container *ngIf="moreContactsIsLoading$ | async">
      <div *ngFor="let avatar of [].constructor(7)" class="flex items-center flex-col w-3/12 mb-8">
        <bey-avatar size="h-[60px] w-[60px] " [isSkeleton]="true"> </bey-avatar>
      </div>
    </ng-container>
  </div>

  <div class="w-full text-center">
    <button
      *ngIf="hasMoreContacts$ | async"
      (click)="getMore()"
      class="text-blue-400 font-medium leading-[16px] text-sm lg:text-base">
      Load more
    </button>
  </div>
</div>
